import type { Response } from '../network/types';
import { isSSR } from '../network/utils';
import { API_VERSION_HEADER_KEY } from './utils/consts';

/**
 * Unified version header processor that works with multiple response types
 */
export const processVersionHeader = (response: Response<any>): void => {
	if (isSSR()) {
		return;
	}

	try {
		// Get previous and latest version headers
		const previousVersionHeader = sessionStorage.getItem(API_VERSION_HEADER_KEY);
		const latestVersionHeader = response.headers[API_VERSION_HEADER_KEY];

		// If the version header is not found or the header is the same as the current header, do not process the response
		if (!latestVersionHeader || latestVersionHeader === previousVersionHeader) {
			return;
		}

		// Store the new version
		sessionStorage.setItem(API_VERSION_HEADER_KEY, latestVersionHeader);

		// Only dispatch event if we already have a previous version in session storage(prevent first load)
		if (!previousVersionHeader) {
			return;
		}

		// Dispatch event to notify React hooks
		window.dispatchEvent(
			new StorageEvent('storage', {
				key: API_VERSION_HEADER_KEY,
				newValue: latestVersionHeader,
				oldValue: previousVersionHeader,
				storageArea: sessionStorage,
			})
		);
	} catch (error) {
		console.error('[Version Header Interceptor] Error processing API response:', error);
	}
};
